import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const SidebarLayout = () => {
  const [selected, setSelected] = useState('Dashboard');
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <>
      <div className="app">
        <Sidebar
          selected={selected}
          setSelected={setSelected}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <main
          className="content"
          style={{
            marginLeft: isCollapsed ? '60px' : '235px',
            transition: 'margin 0.3s ease',
          }}
        >
          <Topbar />
          <Outlet />
        </main>
      </div>
    </>
  );
};

export default SidebarLayout;
